import React, {useState} from "react";
import '../cart_overlay.css'
import { useCart } from "./context4cart";
import { useAuth } from "./authcontext";


export default function WishOverlay({ isbn, titel, preis, autor, onClose }) {
  const [bz, setBz] = useState("");
  const { fetchWishlist } = useCart(); 
  const { user } = useAuth();


  
    const handleSubmit = async (e) => {
      e.preventDefault();

      const caller = user.aml; 
      const session_id = user.session_id;
      const pg_id = user.pgid; 
      const value= user.aml;
  
      const formData = new URLSearchParams();
        formData.append("session_id", session_id);
        formData.append("caller", caller);
        formData.append("value", value);
        formData.append("isbn", isbn);
        formData.append("pg_id", pg_id);
        formData.append("bestellzeichen", bz);

          try {
            const response = await fetch("/api-savemerkzettel", {
              method: "POST",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
              body: formData.toString(),
            });

            const result = await response.json();
            console.log("Merkzettel result:", result);

            //alert("Artikel wurde auf den Merkzettel gesetzt!");
            fetchWishlist();
            onClose();
          } catch (err) {
            console.error("Error:", err);
            alert("Failed to add item.");
          }
    };
  
    return (
      <div className="item2CartOverlay">
        <div className="cartOverlayContent">
          <form onSubmit={handleSubmit}>
            <div className='cartOverlayContentItem'> <h4>Auf die Merkliste:</h4></div>
           
            <div className='cartOverlayTitle cartOverlayContentItem'><h5><b>{titel}</b></h5></div>
            <div className='cartOverlayPAICombinded'>
                <div className='cartOverlayAutor cartOverlayISBN'>{autor}<br/>{isbn}</div>
                
                {/*<div className='cartOverlayPreis'>{preis}€</div>*/}

            </div>
            




            <br/>
            

            <div className='cartOverlayField cartOverlayBZ cartOverlayContentItem'>
                <input type="text" value={bz} onChange={(e) => setBz(e.target.value)} placeholder='Bestellzeichen' />
            </div>        
             
                    
            <br/>        
  
            <div className='cartOverlayContentItem'>
              <button type="submit" className='umbButton'> Hinzufügen</button>
              <button type="button" className='umbButton' onClick={onClose}>Abbrechen</button>
            </div>
          </form>
        </div>
  
       
      </div>
    );
  }